import { render, staticRenderFns } from "./ManualClaims.vue?vue&type=template&id=509549c6"
import script from "./ManualClaims.vue?vue&type=script&lang=js"
export * from "./ManualClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports